import React from 'react';
import { DialogContent, DialogTitle, IconButton } from '@mui/material'
import { fieldsTyps } from 'components/Form';
import { WrapDialogActions, WrapDialog } from './Style'
import { FlexBetween } from 'styles/GlobalStyle';
import { Close } from '@mui/icons-material';

const BasicAlert = (props) => {

    const {
        size, // fullScreen גודל מסויים לפופאפ- לא יכול ללכת ביחד עם האופצייה של
        bg, // רקע שונה לפופאפ
        fullScreen, // הפופאפ מופיע ללא מסגרת עם כותרת ואפשרות סגירה, השתמשנו בשביל להציג סרטון על כל הפופאפ
        closeOnClick, // האם לחיצה בחוץ סוגרת את הפופאפ?
        type,
        children,
        title,
        handleAlert,
        footerActions,
        className, //  נוספת לפופאפ ספציפי
        sx,
        closeIcon // אייקון סגירה חלופי 
    } = props

    const handleClose = () => {
        handleAlert(false)
    }

    const onSubmit = (event) => {
        event.preventDefault();
        handleClose();
    }

    return (
        <WrapDialog
            type={type}
            size={size}
            bg={bg}
            fullWidth
            fullScreen={fullScreen}
            className={className}
            sx={sx}
            onClose={closeOnClick ? handleClose : () => { }}
            open={true}
            PaperProps={{
                component: 'form',
                onSubmit: onSubmit
            }}
        >
            {fullScreen ||
                (size ?
                    <div className='full-screen-title'>
                        <IconButton onClick={handleClose}>
                            <Close />
                        </IconButton>
                    </div>
                    :
                    <DialogTitle className='dialog-title'>
                        <FlexBetween $center={true}>
                            {title}
                            <IconButton onClick={handleClose}>
                                {closeIcon || <Close />}
                            </IconButton>
                        </FlexBetween>
                    </DialogTitle>)}
            <DialogContent>
                {children}
            </DialogContent>
            {footerActions &&
                <WrapDialogActions>
                    {footerActions.map((act, index) => {
                        const Component = fieldsTyps[act.component || "button"]
                        return (
                            <Component key={index} {...act} />)
                    })}
                </WrapDialogActions>
            }
        </WrapDialog>
    );
}

export default BasicAlert
